<!--
 * @Author: your name
 * @Date: 2020-10-09 08:57:57
 * @LastEditTime: 2020-10-28 10:57:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\src\components\login\wxlogin.vue
-->
<!-- 微信登录 -->
<template>
<div class="wxlogin">
    <div class="wx_login">
        <div class="logo">
            <span @click="back()">
                <i class="el-icon-arrow-left"></i>
                返回
            </span>
        </div>
        <h1>微信登录</h1>
        <div class="ercode" id="ercode" v-loading="loading" @click="wxcode">
            <img :src="wxcodeImg">
        </div>
        <p>请使用微信扫描二维码登录</p>
        <button class="gophone" @click="back()">使用手机号登录</button>
    </div>
</div>
</template>

<script>
export default {
    data: function () {
        return {
            // 获取微信登录二维码参数
            wxcodeParams: {
                oper: 'login_ticket'
            },
            // 二维码图片
            wxcodeData: [],
            wxcodeImg: '',
            // 二维码轮询
            _v_t_i: '',
            loading: true
        }
    },
    components: {},
    created: function () {},
    mounted: function () {
        this.wxcode()
    },
    methods: {
        submitForm: function (formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    alert('我要登录了')
                } else {
                    return false
                }
            })
        },
        back: function () {
            let activeName = 'account'
            this.$emit('back', activeName)
            clearTimeout(this._v_t_i)
        },
        // 获取微信二维码
        wxcode() {
            this.oauthapi.wxcode(this.wxcodeParams).then(res => {
                if (res.code == 0) {
                    this.loading = false
                    this.wxcodeData = res.data
                    localStorage.setItem('wxstr', res.data.str)
                    this.wxcodeImg = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + res.data.returnUrl
                    var that = this
                    // 二维码轮询
                    that._v_t_i = setTimeout(function () {

                        that.iswxcode()
                    }, 3000)
                    // 90秒后二维码失效
                    setTimeout(function () {
                        that.wxcodeImg = '../../../static/images/qrcode_invalid.jpg'
                        clearTimeout(that._v_t_i)
                    }, 90000)
                } else if (res.code == -1) {
                    var that = this
                    // 服务器错误2秒后失效
                    setTimeout(function () {
                        that.loading = false
                        that.wxcodeImg = '../../../static/images/qrcode_invalid.jpg'
                        clearTimeout(that._v_t_i)
                    }, 2000)
                }
            })
        },
        // 判断二维码轮询
        iswxcode() {
            this.wxcodeParams.oper = 'login_verify'
            this.wxcodeParams.login_s = this.wxcodeData.extra
            this.oauthapi.iswxcode(this.wxcodeParams).then(res => {
                if (res.code == 405) {
                    var that = this
                    this._v_t_i = setTimeout(function () {
                        that.iswxcode()
                        clearTimeout(that._v_t_i)
                    }, 3000)
                } else if (res.code == -2) {
                    clearTimeout(this._v_t_i)
                    this.$message.error(res.msg)
                    // 微信未绑定手机号
                    let activeName = 'phone'
                    this.$emit('back', activeName)
                } else if (res.code == 0) {
                    clearTimeout(this._v_t_i)
                    localStorage.setItem('token', res.data)
                    localStorage.setItem('isNew', false)
                    /**
                     * 登录成功获取用户信息
                     */
                    this.oauthapi.userInfo().then(res => {
                        localStorage.setItem('userinfo', JSON.stringify(res.data))
                        localStorage.setItem('userId', res.data.userId)
                        this.$router.replace({
                            path: this.$route.query.path || '/home'
                        })
                    })
                }
            })
        }

    }
}
</script>

<style lang="scss" scoped>
.wxlogin {
    width: 580px;
    display: flex;
    justify-content: center;
    height: 720px;

    .wx_login {
        width: 500px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .ercode {
        width: 180px;
        height: 180px;
        border: 1px solid #eeeeee;
        margin: 60px auto 12px auto;
        margin-top: 60px;

        img {
            display: block;
            width: 100%;
            height: 100%;
        }
    }

    .logo {
        margin-top: 40px;
        width: 100%;
        height: 34px;
        color: #66686e;
        cursor: pointer;
    }

    h1 {
        font-size: 30px;
        font-weight: bold;
        color: #34343a;
        text-align: center;
        margin-top: 60px;
    }

    p {
        text-align: center;
        color: #989ea2;
    }

    .gophone {
        color: $btnc;
        width: 150px;
        border: none;
        background: none;
        margin-top: 155px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/login/wxlogin.vue